import axios from "axios";

const url = process.env.REACT_APP_API_URL_REGISTER;
const urlFile = process.env.REACT_APP_API_URL_FILE;
const token = localStorage.getItem("token");
const api = axios.create({
  baseURL: url,
  headers: {
    Authorization: token ? `Bearer ${token}` : "",
  },
});
api.interceptors.request.use(
  (config) => {
    const newToken = localStorage.getItem("token");
    if (newToken) {
      config.headers["Authorization"] = `Bearer ${newToken}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default class PegawaiService {

    getAllDataPegawai() {
        return api.get(`${url}/data/pegawai`);
    }

    getDataPegawaiByNIP(nip) {
    return axios.get(`${url}/data/pegawai/${nip}`);
    }

    async addDataPegawai(data) {
        try {
            const response = await axios.post(`${url}/data/pegawai`, data);
            return response.data;
        } catch (error) {
            throw error.response?.data || { message: error.message };
        }
    }
    async updateDataPegawai(nip, data) {
        try {
            const response = await axios.put(url + `/data/pegawai/${nip}`, data);
            return response.data;
        } catch (error) {
            throw error.response?.data || { message: error.message };
        }
    }
    deleteDataPegawai(nip) {
    return axios.delete(`${url}/data/pegawai/${nip}`);
    }
    getNamaUPT(kdUpt) {
        return axios.get(url + '/getuptbyid/' + kdUpt)
    }
   getAllUPT() {
    return axios.get(`${url}/allupt`);
    }

    getAllRole(){
        return axios.get(`${url}/data/role`);
    }

    getUserByKodeTrader(kodeTrader) {
        return api.get(`/data/usertrader/${kodeTrader}`);
    }
   
    addUserTrader(data) {
        return api.post(`/data/usertrader`, data);
    }
    putDokumen(fileID, file) {
        const formData = new FormData();
        formData.append("file", file);
        return axios.post(urlFile + '/upload?nomorAju=' + fileID, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
    });
    }
    randomString() {
        return api.get(`/data/randomstring/`);
    }
}